exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Price .Price__initial{text-decoration:line-through;padding-left:.5em;font-weight:normal}", ""]);
